/**
 * Created by Shikha Gupta on 2020-08-25.
 */
export class HorribleHeroesEvents {

    // public static readonly UPDATE_XWAYS_WON: string = "HorribleHeroesEvents_UPDATE_XWAYS_WON";
    // public static readonly UPDATE_XWAYS_TOTAL_WON: string = "HorribleHeroesEvents_UPDATE_XWAYS_TOTAL_WON";
    public static readonly PLAY_FS_FIRE_PARTICLES: string = "HorribleHeroesEvents_PLAY_FS_FIRE_PARTICLES";
    public static readonly STOP_FS_FIRE_PARTICLES: string = "HorribleHeroesEvents_STOP_FS_FIRE_PARTICLES";
    public static readonly CHANGE_LAYERS: string = "HorribleHeroesEvents_CHANGE_LAYERS";
    public static readonly PLAY_IDLE: string = "HorribleHeroesEvents_PLAY_IDLE";
    public static readonly STOP_IDLE: string = "HorribleHeroesEvents_STOP_IDLE";
    public static readonly ON_GAME_START: string = "On_Game_Start";
}